<template>
  <v-card tile :ripple="false">
    <v-container fluid>
      <v-row justify="center" align="center">
        <v-col cols="3">
          <user-avatar
            :user="task.user"
            :size="60"
            textSizeClass="title"
          ></user-avatar>
        </v-col>
        <v-col cols="9" class="pt-2 pl-1">
          <v-card-title class="pa-0">
            {{ task.user.name }}
          </v-card-title>
          <v-card-text v-if="task.result" class="pl-0 pb-0 text-body-1">
            <strong>{{ $t('common.result') }}: </strong>
            <span class="font-weight-light">{{ task.result }}</span>
          </v-card-text>
          <v-card-actions class="pb-0">
            <v-spacer></v-spacer>
            <approval-actions @approve="approveTask"></approval-actions>
          </v-card-actions>
        </v-col>
      </v-row>
    </v-container>
  </v-card>
</template>

<script>
import ApprovalActions from '../ApprovalActions';
import UserAvatar from '../../shared/UserAvatar';

export default {
  name: 'approval-task',
  components: {
    ApprovalActions,
    UserAvatar
  },
  props: {
    task: {
      type: Object,
      require: true
    }
  },
  methods: {
    approveTask(approved) {
      this.$emit('approveTask', {
        userId: this.task.userId,
        taskId: this.task.id,
        approved
      });
    }
  }
};
</script>
